module.exports = __webpack_public_path__ + "media/components/assets/images/cold_mobile-0feea85967cfbf95dc3aa07f13cae9d4.png";